export { default } from './copyrights';
